import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { isPersistedLanguage } from "../../../i18n/languages";
import { getAuthTokens } from "../../auth/tokens/tokens";

export function useUpdateLanguagePreference() {
  return useMutation({
    mutationFn: async (language: string) => {
      // The switcher also renders on pre-auth pages (login/signup); skip the PATCH when
      // logged out — the choice is already cached locally and seeded into the signup payload.
      if (!getAuthTokens()?.access_token || !isPersistedLanguage(language)) return;
      await apiClient.patchUserProfilePreferences({ language });
    },
  });
}
